import React from "react";
import "./SectionDivider.scss";

export default function SectionDivider({ label = "BRAVE STEP", subtle = false }) {
  return (
    <div className={`divider ${subtle ? "divider--subtle" : ""}`}>
      <span className="divider__edge" />
      <span className="divider__label foil-text">{label}</span>
      <span className="divider__edge" />
    </div>
  );
}
